import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { fetchCountryDataGeobuf, buildCountryData } from './countries';
import { useCountryStore } from './store/countryStore';
import { App } from './components/App';

const geojson = await fetchCountryDataGeobuf();
if (!geojson) {
    throw new Error('Failed to load country data');
}

const countryData = buildCountryData(geojson);
useCountryStore.getState().setCountryData(countryData);

createRoot(document.getElementById('ui-root')!).render(createElement(App));
